
import React, { useEffect, useState } from 'react'
import MJlogo from '../../../../assets/images/logo/mj.png'
import LogoTwo from '../../../../assets/images/logo/logo-two.png';
import styles from './SurveyForm.module.css';
import TimerWithHours from '../../basic-component/TimerWithHours';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { Button, Container } from 'react-bootstrap';
import '../../shared/sidebar.css';
import { useLocation, useNavigate } from 'react-router-dom';
import SurveyMultiSelectDropdown from '../../basic-component/SurveyMultiSelectDropdown';
import SurveyCheckBox from '../../basic-component/SurveyCheckBox';
import SurveyDynamicRadioButton from '../../basic-component/SurveyDynamicRadioButton';
import SurveyTextArea from '../../basic-component/SurveyTextArea';
import SurveyRadioCheck from '../../basic-component/SurveyRadioCheck';
import SurveyDropDown from '../../basic-component/SurveyDropDown';
import SurveyDynamicMultipleDropDown from '../../basic-component/SurveyDynamicMultipleDropDown';
import SurveyDynamicCheckBox from '../../basic-component/SurveyDynamicCheckBox';
import SurveyDynamicDropDown from '../../basic-component/SurveyDynamicDropDown';
// import SurveyStarRating from '../../basic-component/SurveyStarRating';
import SurveyHidden from '../../basic-component/SurveyHidden';
import useAxiosFetchHeaderData from '../../../hooks/useAxiosFetchHeaderData';
import { apiHostUrl, applicationContextRoot, getSubQuestion, surveyAddForm } from '../../../../constants/constants';
import { useSelector } from 'react-redux';
import CloseFeedbackDetailsWithStar from '../../basic-component/form-component/feedback-form/CloseFeedbackDetailsWithStar';
import SurveyStarRating from '../../basic-component/SurveyStarRating';
import { Card, Row, Col, Form } from 'react-bootstrap';
import Stack from '@mui/material/Stack';
import TextLabel from '../../basic-component/TextLabel';
import PluginSnackbar from '../../basic-component/Snackbar';
import TimerClock from '../../../../assets/images/timer.gif'
import SurveyResponse from './SurveyResponse';
import axios from "axios";
import API_Route from "../../../../constants/api-routes";
import { addSurveyQuestion, removeSurveyQuestion, setFinalPayload, setQuestionAnswerList } from '../../../system/redux/reducers/surveyReducer';
import { useDispatch } from 'react-redux';
import SurveyQuestionnaires from '../../basic-component/SurveyQuestionnaires';
import useAddModal from '../../../hooks/useAddModal';
import SurveyCancelConfirmationModal from  '../../basic-component/Modal/SurveyCancelConfirmationModalBody.jsx';
import { v4 as uuidv4 } from 'uuid';
import ReactModal from '../../basic-component/Modal/AddModalCustomer.jsx';
import { setUserInfo } from '../../../system/redux/reducers/roleReducer.jsx';
import {createMarkup} from "../../basic-component/CommonUtils";
import {isArray} from "util";


const SurveyForm = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isOpen, toggleModal, val } = useAddModal();

  console.log("HI");
  const { surveyData, surveyPayload, questionMap, mandatoryMap, questionAnswerList, finalPayload, surveyList } = useSelector((state) => state.survey);
  const { homeLink, userCurrRole } = useSelector((state) => state.role);
  
  const [modalSize,setModalSize] = useState("");
  const [modalId, setModalId] = useState(`modal-${uuidv4()}`);
  const [modalHeading, setModalHeading] = useState(null);

  if(surveyData==null){
      navigate(applicationContextRoot );
  }
  console.log("surveyData: " + surveyData);
  //console.log(JSON.parse(location.state?.responseSuveyQuestion || location.state?.responseSuveyQuestionParam || null));
  const [surveyFetchData, setSurveyFetchData] = useState(surveyPayload);
  //const [surveyFetchData, setSurveyFetchData] = useState(JSON.parse(location.state?.responseSuveyQuestion || location.state?.responseSuveyQuestionParam || null));
  // console.log(surveyFetchData.data)
  const [surveyQuestionList, setSurveyQuestionList] = useState(surveyData?.surveyList[0]?.categoryList[0]?.questionList || null);
  // console.log(surveyQuestionList);
  const [satisfactionLevel, setSatisfactionLevel] = useState(-1);

  //state variables
  // const { csrfToken } = useSelector(state => state.csrf);
  const { csrfFormTagName, csrfToken } = useSelector((state) => state.csrf);
  const { register, reset, handleSubmit, formState: { errors } } = useForm();
  const [timer, setTimer] = useState(10);
  const { i18n, t } = useTranslation();
  //const [questionAnswerList, setQuestionAnswerList] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [snackbarSwitch, setSnackbarSwitch] = useState(false);
  // const [snackbarMessage, setSnackbarMessage] = useState("");
  const [headers, setHeaders] = useState({
    'X-Csrf-Token': csrfToken,
    'Content-Type': 'application/json'
  });
  const [headersLogout, setHeadersLogout] = useState({
    Accept: "*/*",
    "X-Csrf-Token": csrfToken,
    "Content-Type": "application/json",
  });
  // const handleNavigation = () => {
  //   navigate(applicationContextRoot, { replace: true });
  //   dispatch({ type: "USER_LOGOUT" });
  // };
  const [remarks, setRemarks] = useState({});
  const addSurvey = apiHostUrl + surveyAddForm;
  const [snackbarMessage, setSnackbarMessage] = useState("All mandatory fields must be filled.");
  const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);
  const [response, setRespone] = useState();
  const [openResponse, setOpenResponse] = useState(false);
  
  const [validate, setValidate] = useState(false);
  
  const payloadObject = questionAnswerList.map(curr => ({ ...curr }));

  console.log(payloadObject);
  const closeSuccessSnackbar = () => {
    setOpenSuccessSnackbar(false);
  };

  const handleTimerUpdate = newTime => {
    if (newTime <= 0) {
      // handleClose();
      // onModalCloseHandler();
    } else {
      setTimer(newTime);
    }
  };
  const { fetchData: addSurveyCall } = useAxiosFetchHeaderData({
    url: addSurvey,
    method: 'post',
    body: finalPayload,
    headers: headers,
    onLoad: false,
  });

  const handleLogout = () => {
    try{
      console.log("Logout");
      debugger;
      const formData = csrfFormTagName + "=" + csrfToken;
      async function logout() {
        const response = await axios
          .post(API_Route.logout, formData, { withCredentials: true })
          .then((res) => {
            debugger;
            console.log(res.status);
            if (res.status === 200) {
              // handleNavigation();
            }
          });
      }
      logout();
    }catch(e){
      console.log(e);
    }
  };

  useEffect(() => {
    if (validate) {
      //debugger;
      console.log(submit);
      addSurveyCall().then((res) => {
        console.log(res)
        setRespone(res);
        setSubmit(false);
        //debugger;
        if (res?.data?.success == true) {
          setOpenResponse(true);

          handleLogout();
        }
      });
    }
    else{
      setSnackbarSwitch(true);
    }
  }, [validate])
  useEffect(() => {
    console.log(finalPayload)
    // debugger
    if (submit) {

      validPayload();
    }

  }, [submit])
  useEffect(() => {

  }, [openResponse])

  const handleFormSubmit = () => {

    console.log(questionAnswerList);
    dispatch(setFinalPayload());
    
    setSubmit(true);
  };
  // const [payload, setQuestionAnswerList] = useState({});

  const updatePayload = (newData) => {
    //debugger;
    console.log(newData.id);
    dispatch(setQuestionAnswerList(newData));
    
    console.log(questionAnswerList);
  };

  const addPayload = (newData) => {
    questionAnswerList = [...questionAnswerList, newData];
    //setQuestionAnswerList(prevPayload => [...prevPayload, newData]);
  };
  
  const generatePayload = (questionId, personName) => {
    // debugger;
    let temp = {
      id: questionId,
      answerList: [{
        answerDescription: "",
      }]
    }
    addPayload(temp);
  }

  const validPayload = () => {
    let isValid = true;
    //debugger
    console.log("mandatoryMap: " + mandatoryMap);

    var questionList = finalPayload?.categoryList[0]?.questionList;
    console.log("questionList" + questionList);

    var removableQuestions = questionList?.filter(question => !(question?.answerList?.length > 0));
    if(removableQuestions?.length > 0){
      removableQuestions.forEach(removableSurveyQuestion => {
        questionList.splice(questionList.indexOf(removableSurveyQuestion), 1);
      });
    }

    /* Array(finalPayload?.categoryList[0]?.questionList).forEach(question => {
      if (!(question?.answerList?.length > 0)) {

      }
    }); */

    for (const surveyQuestionId in questionMap) {
      const surveyQuestion = questionMap[surveyQuestionId];
      console.log("Validating surveyQuestion: " + surveyQuestion);
      //debugger;
      if (mandatoryMap.hasOwnProperty(surveyQuestion.id) && mandatoryMap[surveyQuestion.id]) {
        const validatingQuestion = finalPayload.categoryList[0]?.questionList.find(q => q.id === surveyQuestion.id);
        //debugger;
        if (!(validatingQuestion?.answerList?.length > 0)) {
          isValid = false;
          setSubmit(false);
          setSnackbarSwitch(true);
          break;
        }else if(validatingQuestion?.answerList?.length > 0){
          validatingQuestion?.answerList?.forEach(answer => {
            const questionOptionId = answer.questionOptionId;
            const remark = answer.remark;
            let fieldKey = "questionOptionId-" + questionOptionId + "-remarks-isMandatory";
            //debugger;
            if (mandatoryMap.hasOwnProperty(fieldKey) && mandatoryMap[fieldKey] && !remark) {
              isValid = false;
              return;
            }
          });

          if(!isValid){
            setSubmit(false);
            setSnackbarSwitch(true);
            break;
          }
        }
      }
    }

    setValidate(isValid);
  };

  useEffect(() => {
    console.log(mandatoryMap);
  }, [])

  const getSubQuestionURL = apiHostUrl + getSubQuestion;

  const onCancleClick = () =>{
    let selectorString = `#${modalId} .btn-close`;
        setModalSize("mb");
        //setModalHeading("Are you sure you want to cancel")
        toggleModal(
          <SurveyCancelConfirmationModal
             // show={true} 
              onClose={() => {
                  document.querySelector(selectorString).click();
              }}
              onConfirm={handleConfirmCancel}
          />

      )
  }

  const handleConfirmCancel = ()=>{
    handleSurveyLogout();
    
    //dispatch({ type: "USER_LOGOUT" });
  }

  const handleSurveyLogout = () => {
    try{
      console.log("Logout");
      debugger;
      const formData = csrfFormTagName + "=" + csrfToken;
      async function logout() {
        const response = await axios
          .post(API_Route.logout, formData, { withCredentials: true })
          .then((res) => {
            debugger;
            console.log(res.status);
            if (res.status === 200) {
              const userData = {
                homeLink: " ",
              };
              dispatch(setUserInfo(userData))
              navigate(applicationContextRoot, { replace: true });
            }
          });
      }
      logout();
    }catch(e){
      console.log(e);
    }
  };
  const endDate = surveyData?.surveyList[0]?.endDate;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  let isSurveyEnded = false;

  if (endDate) {
    const surveyEndDate = new Date(endDate);
    surveyEndDate.setHours(0, 0, 0, 0);

    isSurveyEnded = surveyEndDate < today;
  }
  useEffect(() => {
  if (isSurveyEnded) {
    setSnackbarSwitch(false);
    setSnackbarMessage("");
  } else {
    setSnackbarMessage(t('label.new.survey.mandatoryFieldValidation'));
  }
}, [isSurveyEnded]);

  return (
    <>
      <ReactModal
                    show={isOpen}
                    handleClose={toggleModal}
                    componentToRender={val}
                    title={""}
                    size={modalSize}
                    modalId={modalId}
                   // centered={true}
                    style={{zIndex:'10000'}}
                />
      <div className='survey-main vh-100'>
        {/* <PluginSnackbar
          open={openSuccessSnackbar}
          message={snackbarMessage}
          onClose={closeSuccessSnackbar}
        /> */}

        <Container fluid>

          <Row className="vh-100">
            <Col lg="6" className='my-3 mb-5'>
              <div className='logo mb-3'>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-end"
                  spacing={2}>
                  <img src={MJlogo}></img>
                  <img src={LogoTwo}></img>
                </Stack>

                {/* <img src={LogoTwo}></img> */}
              </div>
              {isSurveyEnded ? (
<Card className='survey-section'>
  <Card.Body
    className='d-flex justify-content-center align-items-center'
    style={{ minHeight: '300px' }}
  >
    <h3 style={{ color: 'red' }}>
      {t('label.survey.expired.message')}
    </h3>
  </Card.Body>
</Card>
  ) : openResponse == false ? (
                <>
                  <Card className='survey-section'>
                    <Card.Header className='light-blue-bg fs-5 fw-medium px-4'>
                      <Row>
                        <Col>
                          {surveyData?.surveyList[0]?.name}
                        </Col>
                        <Col lg="auto" className='timer-area d-flex align-items-center'>
                          {surveyData?.surveyList[0]?.surveyTimerEnable && (
                            <div>
                              <img src={TimerClock} alt="Timer Clock" />
                              <TimerWithHours
                                text={t('label.new.survey.timeleft')}
                                countdown={surveyData?.surveyList[0]?.surveyTime}
                                onTimerUpdate={handleTimerUpdate}
                              />
                            </div>
                          )}

                        </Col>
                      </Row>
                    </Card.Header>
                    {/* <div > */}

                    {surveyData?.surveyList[0]?.surveyTimerEnable ? (
                      <div className='text-end py-2'>
                        {/* <TimerWithHours text={t('label.new.survey.timeleft')} countdown={surveyData?.surveyList[0]?.surveyTime} onTimerUpdate={handleTimerUpdate} /> */}
                      </div>
                    ) : null}
                    <div>
                      <form onSubmit={handleFormSubmit}>
                        <Card.Body className='p-4 overflow-auto'>
                          {isArray(surveyList) && surveyList?.map(categories => {
                            return categories?.map(category => {
                              return (<>
                                <Row>
                                  <Col>
                                    <div className={'survey-category-title-instructions'}
                                         dangerouslySetInnerHTML={createMarkup(category.categoryName)}></div>
                                  </Col>
                                </Row>
                                <SurveyQuestionnaires questions={category.qSet} mode={5}/>
                              </>)
                            })
                          })}
                        </Card.Body>

                        <Card.Footer className='bg-transparent d-flex justify-content-between'>
                          <div>
                            <Button variant='outline-dark' type="button" onClick={() => {
                              onCancleClick();
                              console.log("Reset button clicked")
                            }} className='me-3'>Cancel</Button>
                          </div>
                          <div className='text-end'>
                            <Button variant='outline-dark' type="button" onClick={() => {
                              reset();
                              console.log("Reset button clicked")
                            }} className='me-3'>Reset</Button>
                            <Button variant='primary' type="button" onClick={() => (handleFormSubmit())}>Submit</Button>
                          </div>
                        </Card.Footer>
                      </form>
                    </div>

                  </Card>
                </>
              ) : (<>
               <SurveyResponse props={response} surveyData={surveyList}></SurveyResponse>   
                </>)}
            </Col>
          </Row>
        </Container>
      </div>
      <PluginSnackbar
                open={snackbarSwitch}
                message={snackbarMessage}
                onClose={() => {
                    setSnackbarSwitch(false);
                }}
            />
    </>


  )
}
export default SurveyForm; 
